/**
 * Heat Report Module Color Constants
 *
 * Centralized color definitions for the heat report module.
 * These colors are used for asset identification and heat status visualization.
 */

export const heatReportColors = {
  // Asset-specific colors for visual identification of process areas
  assets: {
    eaf: "#dae8fc", // EAF - Light Blue
    lmf: "#d5e8d4", // LMF - Light Green
    caster: "#f4d2d2", // Caster - Light Red/Pink
    lab: "#479dc4", // LAB - Steel Blue
    default: "", // Will use theme.palette.grey[300] as fallback
  },

  // Heat status colors for process state visualization
  status: {
    scheduled: "#0288D1", // Light Blue - Scheduled
    melting: "#FF7043", // Orange - Melting
    tapped: "#FFD600", // Yellow - Tapped
    opened: "#43A047", // Green - Opened
    closed: "#607D8B", // Blue Grey - Closed
    returned: "#8D6E63", // Brown - Returned
    finished: "#3F51B5", // Indigo - Finished
    unknown: "#484848", // Dark Grey - Unknown
  },
} as const;

/**
 * Asset ID to color key mapping
 */
export const assetIdToColorKey: {
  [assetId: number]: keyof typeof heatReportColors.assets;
} = {
  11: "eaf",
  12: "lmf",
  13: "caster",
  15: "lab",
};

/**
 * Asset ID to determine if text should be white (for dark backgrounds)
 */
export const assetRequiresWhiteText: { [assetId: number]: boolean } = {
  15: true, // LAB has dark background
};
